export default __webpack_public_path__ + "static/media/pdf-document.4b57936d.svg";